<template>
    <div id="step-2" class="step step-2" :class="{active: activeStep == 2}">
        <div class="line"></div>
        <div class="number">{{ step }}</div>
        <div class="title">{{ title }}</div>
        <mu-paper class="content" :z-depth="1">

            <mu-row justify-content="center" align-items="center" class="item">
                <mu-col span="8" sm="8" md="8" lg="8" xl="8" class="description">
                    <h3>Grupos</h3>
                    Selecione os grupos que deseja adicionar ao envio.
                </mu-col>
                <mu-col span="3" sm="3" md="3" lg="3" xl="3" class="total-contacts">
                    <span>{{ countContactsFromGroups() }}</span>
                    Contato(s)
                </mu-col>
                <mu-col span="1" sm="1" md="1" lg="1" xl="1" class="more-options">
                    <a href="javascript:;" @click="handleGroupsDialog(true)">
                        <font-awesome-icon icon="plus" />
                    </a>
                </mu-col>
            </mu-row>

            <mu-row justify-content="center" align-items="center" class="item">
                <mu-col span="8" sm="8" md="8" lg="8" xl="8" class="description">
                    <h3>Contatos</h3>
                    Selecione os contatos que deseja adicionar ao envio.
                </mu-col>
                <mu-col span="3" sm="3" md="3" lg="3" xl="3" class="total-contacts">
                    <span>{{ form.contacts.length }}</span>
                    Contato(s)
                </mu-col>
                <mu-col span="1" sm="1" md="1" lg="1" xl="1" class="more-options">
                    <a href="javascript:;" @click="handleContactsDialog(true)">
                        <font-awesome-icon icon="plus" />
                    </a>
                </mu-col>
            </mu-row>

            <mu-row justify-content="center" align-items="center" class="item">
                <mu-col span="8" sm="8" md="8" lg="8" xl="8" class="description">
                    <h3>Informar contatos</h3>
                    Informe manualmente os números dos contatos.
                </mu-col>
                <mu-col span="3" sm="3" md="3" lg="3" xl="3" class="total-contacts">
                    <span>{{ inform_contacts_validate.length }}</span>
                    Contato(s)
                </mu-col>
                <mu-col span="1" sm="1" md="1" lg="1" xl="1" class="more-options">
                    <a href="javascript:;" @click="handleInformsDialog(true)">
                        <font-awesome-icon icon="plus" />
                    </a>
                </mu-col>
            </mu-row>

            <!-- Selecionar grupos -->
            <mu-dialog width="900" scrollable :open.sync="groups.open">
                <div class="dialog-groups">
                    <mu-row gutter>
                        <mu-col span="12" sm="12" md="12" lg="12" xl="12">
                            <div class="dialog-box-search">
                                <font-awesome-icon icon="search" />
                                <input type="text" v-model="groups.filter" placeholder="_ Filtre os grupos e subgrupos">
                            </div>
                        </mu-col>
                        <mu-col span="12" sm="6" md="6" lg="6" xl="6">
                            <h3>Selecione os Grupos / Subgrupos</h3>
                        </mu-col>
                        <mu-col span="12" sm="6" md="6" lg="6" xl="6">
                            <h3>Grupos / Subgrupos selecionados</h3>
                        </mu-col>
                    </mu-row>
                    <mu-row gutter>
                        <mu-col span="12" sm="6" md="6" lg="6" xl="6">
                            <div class="dialog-box-result dialog-box-scroll">
                                <table class="mu-table">
                                    <thead>
                                        <tr>
                                            <th>Nome</th>
                                            <th class="is-center">Contatos</th>
                                            <th class="is-center"></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(item, key) in groupsFilter" :key="key">
                                            <td>
                                                <span v-if="item.group_id">
                                                    {{ item.name }}<br>
                                                    <small>Grupo: {{ item.group.name }}</small>
                                                </span>
                                                <span v-else>
                                                    {{ item.name }}
                                                </span>
                                            </td>
                                            <td class="is-center">{{ item.totalcontacts }}</td>
                                            <td class="is-center">
                                                <font-awesome-icon icon="plus" @click="addGroup(item)" v-if="item.totalcontacts > 0" class="icon-sm icon-margin-left color-green cursor-pointer"/>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </mu-col>
                        <mu-col span="12" sm="6" md="6" lg="6" xl="6">
                            <div class="dialog-box-selecteds dialog-box-scroll">
                                <table class="mu-table" v-if="form.groups.length > 0">
                                    <thead>
                                        <tr>
                                            <th>Nome</th>
                                            <th class="is-center">Contatos</th>
                                            <th class="is-center"></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(item, key) in form.groups" :key="key">
                                            <td>
                                                <span v-if="item.group_id">
                                                    {{ item.name }}<br>
                                                    <small>Grupo: {{ item.group.name }}</small>
                                                </span>
                                                <span v-else>
                                                    {{ item.name }}
                                                </span>
                                            </td>
                                            <td class="is-center">{{ item.totalcontacts }}</td>
                                            <td class="is-center">
                                                <font-awesome-icon icon="times" @click="removeGroup(item)" class="icon-sm icon-margin-left color-red cursor-pointer"/>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                <div v-else class="box-empty">
                                    <font-awesome-icon icon="address-book" class="icon-big-extra"/><br>
                                    Você não adicionou nenhum grupo.
                                </div>
                            </div>
                        </mu-col>
                    </mu-row>
                    <div class="dialog-box-finish">
                        <mu-flex justify-content="end" align-items="center">
                            <div>Total de {{ countContactsFromGroups() }} contatos selecionados</div>
                            <mu-button round color="primary" @click="handleGroupsDialog(false)">
                                <font-awesome-icon icon="check" class="icon-md icon-margin-left"/>
                                Ok
                            </mu-button>
                        </mu-flex>
                    </div>
                </div>
            </mu-dialog>

            <!-- Selecionar contatos individuais -->
            <mu-dialog width="900" scrollable :open.sync="contacts.open">
                <div class="dialog-contacts">
                    <mu-row gutter>
                        <mu-col span="12" sm="12" md="12" lg="12" xl="12">
                            <div class="dialog-box-search">
                                <font-awesome-icon icon="search" />
                                <input type="text" v-model="contacts.term" @keyup.enter="searchContact()" placeholder="_ Digite o nome ou telefone do contato">
                                <mu-button @click="searchContact()">
                                    <span v-if="!contacts.loading">Buscar</span>
                                    <span v-else><mu-circular-progress color="#fff" :size="16" :stroke-width="1"></mu-circular-progress></span>
                                </mu-button>
                            </div>
                        </mu-col>
                        <mu-col span="12" sm="6" md="6" lg="6" xl="6">
                            <h3>Selecione os contatos</h3>
                        </mu-col>
                        <mu-col span="12" sm="6" md="6" lg="6" xl="6">
                            <h3>Contatos selecionados</h3>
                        </mu-col>
                    </mu-row>
                    <mu-row gutter>
                        <mu-col span="12" sm="6" md="6" lg="6" xl="6">
                            <div class="dialog-box-result dialog-box-scroll">
                                <table class="mu-table" v-if="!contacts.loading && contacts.list.length > 0">
                                    <thead>
                                        <tr>
                                            <th>Nome</th>
                                            <th>Telefone</th>
                                            <th class="is-center"></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(item, key) in contacts.list" :key="key">
                                            <td>{{ item.firstname }} {{ item.lastname }}</td>
                                            <td>{{ item.phone }}</td>
                                            <td class="is-center">
                                                <font-awesome-icon icon="plus" @click="addContact(item)" class="icon-sm icon-margin-left color-green cursor-pointer"/>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                <div v-else-if="!contacts.loading" class="box-empty">
                                    <font-awesome-icon icon="search" class="icon-big-extra icon-margin-left"/><br><br>
                                    Nenhum contato para exibir, faça uma busca para listar.
                                </div>
                                <div v-if="contacts.loading">
                                    <br><br>
                                    <mu-loading text="Aguarde... Pesquisando contatos..."></mu-loading>
                                </div>
                            </div>
                        </mu-col>
                        <mu-col span="12" sm="6" md="6" lg="6" xl="6">
                            <div class="dialog-box-selecteds dialog-box-scroll">
                                <table class="mu-table" v-if="form.contacts.length > 0">
                                    <thead>
                                        <tr>
                                            <th>Nome</th>
                                            <th>Telefone</th>
                                            <th class="is-center"></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(item, key) in form.contacts" :key="key">
                                            <td>{{ item.name }}</td>
                                            <td>{{ item.phone }}</td>
                                            <td class="is-center">
                                                <font-awesome-icon icon="times" @click="excludeNumberContacts(item.id)" class="icon-sm icon-margin-left color-red cursor-pointer"/>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                <div v-else class="box-empty">
                                   <font-awesome-icon icon="address-book" class="icon-big-extra"/><br><br>
                                    Você não adicionou nenhum contato.
                                </div>
                            </div>
                        </mu-col>
                    </mu-row>
                    <div class="dialog-box-finish">
                        <mu-flex justify-content="end" align-items="center">
                            <div>Total de {{ form.contacts.length }} contatos selecionados</div>
                            <mu-button round color="primary" @click="handleContactsDialog(false)">
                                <font-awesome-icon icon="check" class="icon-md icon-margin-left"/>
                                Ok
                            </mu-button>
                        </mu-flex>
                    </div>
                </div>
            </mu-dialog>

            <!-- Informar contatos em um box -->
            <mu-dialog width="900" scrollable :open.sync="informs.open">

                <div class="dialog-inform-contacts">

                    <mu-row gutter>
                        <mu-col span="12" sm="6" md="6" lg="6" xl="6">
                            <h3>Informe os telefones</h3>
                        </mu-col>
                        <mu-col span="12" sm="6" md="6" lg="6" xl="6">
                            <h3>Telefones informados</h3>
                        </mu-col>
                    </mu-row>

                    <mu-row gutter>
                        <mu-col span="12" sm="6" md="6" lg="6" xl="6">
                            <div class="dialog-box-result dialog-box-scroll" style="padding: 15px;">
                                <div v-if="!informs.validate && !informs.loading">
                                    <div>
                                        Informar números de telefones, separados por vírgula. <br>
                                        Ex.: 47999994444,47999993333
                                    </div>
                                    <mu-form-item prop="textarea">
                                        <mu-text-field multi-line :rows="6" :rows-max="6" v-model="form.inform_contacts"></mu-text-field>
                                    </mu-form-item>
                                    <mu-flex justify-content="start" align-items="center">
                                        <mu-button round color="secondary" @click="checkInformContacts()">
                                            <font-awesome-icon icon="check" class="icon-md icon-margin-left"/>
                                            Validar
                                        </mu-button>
                                        <mu-button round @click="handleInformsDialog(false)">
                                            Cancelar
                                        </mu-button>
                                    </mu-flex>
                                </div>

                                <mu-loading v-if="informs.loading" text="Aguarde... Validando os números..."></mu-loading>

                                <div v-if="informs.validate">
                                    <br>
                                    <mu-row gutter>
                                        <mu-col span="12" sm="12" md="6" lg="6" xl="6">
                                            <div v-if="informs.result.correts" class="result-numbers corrects">
                                                <font-awesome-icon icon="check" class="icon-md icon-margin-left"/><br>
                                                {{ informs.result.correts.totalvalid || 0 }} números válidos
                                            </div>
                                        </mu-col>
                                        <mu-col span="12" sm="12" md="6" lg="6" xl="6">
                                            <div v-if="informs.result.incorrets" class="result-numbers incorrects">
                                                <font-awesome-icon icon="times-circle" class="icon-md icon-margin-left"/><br>
                                                {{ informs.result.incorrets.totalinvalid || 0 }} números inválidos
                                            </div>
                                        </mu-col>
                                    </mu-row>
                                    <br>
                                    <div v-if="informs.result.correts && informs.result.correts.totalvalid > 0">
                                        <h3 style="text-align: center;">Deseja incluir os números válidos?</h3>
                                        <mu-flex justify-content="center" align-items="center">
                                            <mu-button round color="primary" @click="includeNumbers()">
                                                <font-awesome-icon icon="check" class="icon-md icon-margin-left"/>
                                                Sim
                                            </mu-button>
                                            <mu-button round @click="handleInformsDialog(true)">
                                                Não
                                            </mu-button>
                                        </mu-flex>
                                    </div>
                                    <div v-else>
                                        <mu-flex justify-content="center" align-items="center">
                                            <mu-button round color="#ddd" textColor="#888" @click="handleInformsDialog(true)">
                                                Ok
                                            </mu-button>
                                        </mu-flex>
                                    </div>
                                </div>
                            </div>
                        </mu-col>
                        <mu-col span="12" sm="6" md="6" lg="6" xl="6">
                            <div class="dialog-box-selecteds dialog-box-scroll">
                                <table class="mu-table" v-if="inform_contacts_validate.length > 0">
                                    <thead>
                                        <tr>
                                            <th>Telefone</th>
                                            <th class="is-center"></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(item, key) in inform_contacts_validate" :key="key">
                                            <td>{{ item }}</td>
                                            <td class="is-center">
                                                 <font-awesome-icon icon="times" @click="excludeNumberListInform(item)" class="icon-md icon-margin-left cursor-pointer color-red"/>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </mu-col>
                    </mu-row>

                    <div class="dialog-box-finish">
                        <mu-flex justify-content="end" align-items="center">
                            <div>Total de {{ inform_contacts_validate.length }} contatos selecionados</div>
                            <mu-button round color="primary" @click="handleInformsDialog(false)">
                                <font-awesome-icon icon="check" class="icon-md icon-margin-left"/>
                                Ok
                            </mu-button>
                        </mu-flex>
                    </div>

                </div>

            </mu-dialog>

        </mu-paper>
        <mu-paper class="buttons" :z-depth="1">
            <mu-flex justify-content="center" align-items="center">
                <mu-button color="#EEF1F3" textColor="#666" round @click="handlePrev()">
                    <font-awesome-icon icon="chevron-left" class="icon-md icon-margin-left"/>
                    Voltar
                </mu-button>
                <mu-button round @click="validateContacts()" color="primary">
                    Próximo
                    <font-awesome-icon icon="chevron-right" class="icon-md icon-margin-right"/>
                </mu-button>
            </mu-flex>
        </mu-paper>
    </div>
</template>

<script>
    import GroupsServices from '@/services/contacts/groups'
    import ContactsServices from '@/services/contacts/contacts'
    import CampaignsServices from '@/services/services/sms'

    export default {
        name: 'campaign-step-contacts',
        props: ['activeStep', 'step', 'title', 'form'],

        // ╔╦╗╔═╗╔╦╗╔═╗
        //  ║║╠═╣ ║ ╠═╣
        // ═╩╝╩ ╩ ╩ ╩ ╩

        data () {
            return {
                options: {
                    groups: []
                },
                inform_contacts_validate: [],
                groups: {
                    open: false,
                    filter: ''
                },
                contacts: {
                    search: false,
                    loading: false,
                    open: false,
                    term: '',
                    list: []
                },
                informs: {
                    title: 'Informe os contatos',
                    open: false,
                    validate: false,
                    loading: false,
                    result: {}
                }
            }
        },

        // ╔═╗╔═╗╔╦╗╔═╗╦ ╦╔╦╗╔═╗╔╦╗
        // ║  ║ ║║║║╠═╝║ ║ ║ ║╣  ║║
        // ╚═╝╚═╝╩ ╩╩  ╚═╝ ╩ ╚═╝═╩╝

        computed: {

            /**
             * Transforma uma string de contatos telefônicos em um array
             */
            inform_contacts () {
                return this.form.inform_contacts ? this.form.inform_contacts.split(',') : []
            },

            groupsFilter () {
                return this.options.groups.filter((item) => {
                    return item.name.toLowerCase().includes(this.groups.filter.toLowerCase()) || (item.group && item.group.name.toLowerCase().includes(this.groups.filter.toLowerCase()))
                })
            }
        },

        // ╔╦╗╔═╗╦ ╦╔╗╔╔╦╗╔═╗╔╦╗
        // ║║║║ ║║ ║║║║ ║ ║╣  ║║
        // ╩ ╩╚═╝╚═╝╝╚╝ ╩ ╚═╝═╩╝

        async mounted () {
            try {
                this.$eventHub.$emit('loading', true, 'Aguarde... Carregando configurações...')
                await this.loadGroups()
            } catch (e) {
                this.$eventHub.$emit('snackbar', 'error', e.message || 'Não foi possível carregar as configurações.')
            } finally {
                this.$eventHub.$emit('loading', false)
            }
        },

        // ╔╦╗╔═╗╔╦╗╦ ╦╔═╗╔╦╗╔═╗
        // ║║║║╣  ║ ╠═╣║ ║ ║║╚═╗
        // ╩ ╩╚═╝ ╩ ╩ ╩╚═╝═╩╝╚═╝

        methods: {

            /**
             * Chama o evento handlePrev do elemento pai
             */
            handlePrev () {
                this.$emit('handlePrev')
            },

            /**
             * Chamando o emit para dar sequência no cadastro
             */
            handleNext () {
                this.$emit('handleNext', this.form)
            },

            /**
             * Carrega a lista de grupos
             */
            async loadGroups () {
                try {
                    let result = await GroupsServices.all()
                    if (result && result.status) {
                        this.options.groups = result.results
                    }
                } catch (e) {
                    this.$eventHub.$emit('snackbar', 'error', e.message || 'Não foi possível carregar os grupos.')
                }
            },

            /**
             * Faz uma contagem de contatos por grupo selecionado
             */
            countContactsFromGroups () {
                return this.form.groups.reduce((total, item) => {
                    return item.totalcontacts + total
                }, 0)
            },

            /**
             * Habilita ou desabilita o dialogo para grupo
             */
            handleGroupsDialog (value) {
                this.groups.open = value
            },

            /**
             * Habilita ou desabilita o dialogo para procurar contato individual
             */
            handleContactsDialog (value) {
                this.contacts.open = value
            },

            /**
             * Habilita ou desabilita o dialogo para contatos informados
             */
            handleInformsDialog (value) {
                this.informs.open = value
                this.informs.result = {}
                this.informs.validate = false
                this.form.inform_contacts = ''
            },

            /**
             * Responsável por fazer uma busca de um contato
             */
            async searchContact () {
                try {
                    if (!this.contacts.term) {
                        this.$eventHub.$emit('snackbar', 'error', 'Você precisa informar um termo para busca.', false)
                        return
                    }

                    if (this.contacts.term.length < 3) {
                        this.$eventHub.$emit('snackbar', 'error', 'Você precisa digitar pelo menos 3 ou mais caracteres.', false)
                        return
                    }

                    this.contacts.search = true
                    this.contacts.loading = true
                    this.contacts.list = []

                    let result = await ContactsServices.search(this.contacts.term)

                    if (result && result.status) {
                        if (result.results.length > 0) {
                            this.contacts.search = false
                        }
                        this.contacts.list = result.results
                        return
                    } else if (result && result.code === 422) {
                        for (const key in result.results.errors) {
                            if (result.results.errors.hasOwnProperty(key)) {
                                const element = result.results.errors[key]
                                this.$eventHub.$emit('snackbar', 'error', element.message, false)
                                return
                            }
                        }
                        return
                    }

                    throw Error(result.message)
                } catch (e) {
                    this.$eventHub.$emit('snackbar', 'error', e.message || `Não foi possível buscar o contato ${this.contacts.term}.`)
                } finally {
                    this.contacts.loading = false
                }
            },

            /**
             * Adiciona o contato encontrado na lista
             */
            addContact (contact) {
                // Verificando se o contato já está na lista
                let result = this.form.contacts.find((item) => {
                    return item.id === contact.id
                })

                // Removendo o contato selecionado da lista de busca
                this.contacts.list = this.contacts.list.filter((item) => {
                    return item.id !== contact.id
                })

                // Se o contato não estiver na lista adicionamos
                if (!result) {
                    this.form.contacts.push({
                        id: contact.id,
                        name: (contact.firstname ? `${contact.firstname || ''} ${contact.lastname || ''}` : contact.phone),
                        phone: contact.phone
                    })
                    this.$eventHub.$emit('snackbar', 'success', `O contato ${contact.firstname} ${contact.lastname} foi adicionado com sucesso.`)
                } else {
                    this.$eventHub.$emit('snackbar', '', `Você já adicionou o contato ${contact.firstname} ${contact.lastname}.`)
                }
            },

            /**
             * Faz uma validação de contatos
             */
            async checkInformContacts () {
                try {
                    this.informs.loading = true
                    this.informs.title = 'Validando...'
                    this.informs.validate = false

                    let numbers = this.inform_contacts.join(',')

                    let result = await ContactsServices.validate({
                        numbers
                    })
                    if (result) {
                        this.informs.title = 'Resultado da validação'
                        this.informs.result = result
                        this.informs.validate = true
                        return
                    }

                    throw Error()
                } catch (e) {
                    this.$eventHub.$emit('snackbar', 'error', e.message || 'Não foi possível validar os contatos.')
                } finally {
                    this.informs.loading = false
                }
            },

            /**
             * Faz uma validação dos contatos que serão incluidos
             */
            includeNumbers () {
                let contacts = []

                if (this.informs.result.correts.numvalid.includes(',')) {
                    let array = this.informs.result.correts.numvalid.split(',')
                    contacts = array.filter((item) => {
                        return !this.inform_contacts_validate.includes(item)
                    })
                } else {
                    if (!this.inform_contacts_validate.includes(this.informs.result.correts.numvalid)) {
                        contacts = [this.informs.result.correts.numvalid]
                    }
                }

                this.inform_contacts_validate = [
                    ...this.inform_contacts_validate,
                    ...contacts
                ]

                this.handleInformsDialog(true)
            },

            /**
             * Método utiliza nos badges para remover um contato número
             */
            excludeNumberContacts (id) {
                this.form.contacts = this.form.contacts.filter((item) => {
                    return item.id !== id
                })
            },

            /**
             * Método utiliza nos badges para remover um grupo
             */
            excludeNumberGroups (id) {
                this.form.groups = this.form.groups.filter((item) => {
                    return item.id !== id
                })
            },

            /**
             * Método utiliza nos badges para remover um contato informado
             */
            excludeNumberListInform (number) {
                this.inform_contacts_validate = this.inform_contacts_validate.filter((item) => {
                    return item !== number
                })
            },

            /**
             * Faz uma validação dos contatos
             */
            async validateContacts () {
                try {
                    this.$eventHub.$emit('loading', true, 'Aguarde... validando todos os contatos adicionados.')

                    let contactsGroups = this.form.groups.map((item) => {
                        return item.id
                    })

                    let contactsContacts = this.form.contacts.map((item) => {
                        return item.id
                    })

                    let contactsInform = this.inform_contacts_validate

                    let data = {
                        groups: contactsGroups,
                        contacts: contactsContacts,
                        inform_contacts: contactsInform
                    }

                    let result = await CampaignsServices.validateTotalContacts(data)

                    // await this.validateAllContacts()

                    if (result && result.status) {
                        if (this.countContactsFromGroups() === 0 && this.form.contacts.length === 0 && this.inform_contacts_validate.length === 0) throw new Error()
                        this.form.inform_contacts = this.inform_contacts_validate
                        this.form.totalcontacts = result.results.totalcontacts
                        this.handleNext()
                        return
                    } else if (result && result.code === 400) {
                        this.$eventHub.$emit('snackbar', 'error', result.message, false)
                        return
                    } else if (result && result.code === 422) {
                        for (const key in result.results.errors) {
                            if (result.results.errors.hasOwnProperty(key)) {
                                const element = result.results.errors[key]
                                this.$eventHub.$emit('snackbar', 'error', element.message, false)
                                return
                            }
                        }
                        return
                    }
                    throw Error(result.message)
                } catch (e) {
                    this.$eventHub.$emit('snackbar', 'error', 'Você precisa selecionar algum grupo, contatos ou informa-los.')
                } finally {
                    this.$eventHub.$emit('loading', false)
                }
            },

            // async validateAllContacts () {
            //     try {
            //         let contactsGroups = this.form.groups.map((item) => {
            //             return item.id
            //         })

            //         let contactsContacts = this.form.contacts.map((item) => {
            //             return item.id
            //         })

            //         let contactsInform = this.inform_contacts_validate

            //         let data = {
            //             groups: contactsGroups,
            //             contacts: contactsContacts,
            //             inform_contacts: contactsInform
            //         }

            //         let result = await CampaignsServices.validateTotalContacts(data)

            //         if (result && result.status) {
            //             this.form.totalcontacts = result.results.totalcontacts
            //             return
            //         } else if (result && result.code === 400) {
            //             this.$eventHub.$emit('snackbar', 'error', result.message, false)
            //             return
            //         } else if (result && result.code === 422) {
            //             for (const key in result.results.errors) {
            //                 if (result.results.errors.hasOwnProperty(key)) {
            //                     const element = result.results.errors[key]
            //                     this.$eventHub.$emit('snackbar', 'error', element.message, false)
            //                     return
            //                 }
            //             }
            //             return
            //         }

            //         throw Error(result.message)
            //     } catch (e) {
            //         this.$eventHub.$emit('snackbar', 'error', e.message || 'Não foi possível validar a quantidade de contatos.')
            //     } finally {
            //         this.$eventHub.$emit('loading', false)
            //     }
            // },

            addGroup (item) {
                this.form.groups.push(item)
                this.options.groups = this.options.groups.filter((i) => {
                    return i.id !== item.id
                })
            },

            removeGroup (item) {
                this.form.groups = this.form.groups.filter((i) => {
                    return i.id !== item.id
                })
                this.options.groups.push(item)
            }
        }
    }
</script>

<style lang="stylus" scoped>

    @import './../../../assets/stylus/bootstrap.styl'

    .dialog-groups, .dialog-contacts, .dialog-inform-contacts

        .result-numbers
            text-align center
            margin 20px 0 40px 0
            &.incorrects
                color $red
            &.corrects
                color $green

        .cursor-pointer
            cursor pointer

        h3
            margin 10px 0 5px 0
            color $primary

        .dialog-box-search

            svg
                position absolute
                margin 12px 0 0 12px
                color $grey

            input
                color $grey
                background lighten($grey, 90%)
                padding 10px 0
                text-indent 40px
                font-size 12px
                width 100%
                border 1px #ddd solid
                border-bottom-width 2px

        &.dialog-contacts

            .dialog-box-search

                input
                    width 80%

                button
                    padding 20px 0
                    width 18%
                    font-size 12px
                    margin-left 2%
                    background $grey
                    border 0
                    color #fff
                    cursor pointer
                    border-radius 50px

        .dialog-box-scroll
            height 300px
            overflow hidden
            overflow-y scroll
            border 1px #ddd solid
            span
                font-weight bold
                small
                    color #aaa
                    font-weight normal
                    text-transform uppercase

        .box-empty
            text-align center
            padding 50px 0

        .dialog-box-finish
            padding-top 15px
            .mu-button
                margin-left 15px

        .mu-table
            width 100%
            tr
                color #999
                height auto
                &:hover
                    background lighten($primary, 96%)
                    color $primary
                th
                    background lighten($grey, 90%)
                    background $primary
                    padding 6px 2px 2px 6px
                    font-size 12px
                    color #fff
            td
                padding 6px 2px 2px 6px
                font-size 12px

        table, th, td
            border-collapse collapse

    .step-2

        .content
            padding 0

            .row
                border-bottom 1px #e0e0e0 solid

                > div
                    height 70px

                .description
                    padding 14px 20px
                    line-height 20px
                    color #9fa9ae
                    h3
                        color $primary
                        margin 0
                        padding 0

                .total-contacts
                    background #fafbfb
                    text-align center
                    font-size 10px
                    text-transform uppercase
                    color #9fa9ae
                    padding 20px
                    span
                        line-height 22px
                        font-size 22px
                        font-weight bold
                        display block

                .more-options
                    background #f5f6f7
                    text-align center
                    color #9fa9ae
                    a
                        padding 22px 0
                        color #9fa9ae
                        display block
                        height 100%

    /* Tablet >= 768 pixels */
    @media (min-width: 768px)

        .step-2

            .groups

                .alert
                    max-width 60%

</style>
